<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <app-filter [filters]="filters()" (filterChange)="applyFilter($event)" />
    @if (chartMetrics) {
      <app-metric-selector
        [data]="totalData"
        [previousPeriodData]="previousTotalData"
        (chartMetricsChanges)="selectMetrics($event)"
        [pageMetrics]="chartMetrics"
        [localStorageKey]="'SalesAndAdvertising_' + accountType"
      />
    }
    @if (!isGlobalChartHidden) {
      <chart-layout
        closable
        withDateAggregation
        withEventAnnotation
        [disableEventAnnotation]="disableEventAnnotation"
        [allEventAnnotationTypes]="allEventAnnotationTypes"
        (aggregationChange)="selectAggreation($event)"
        [allUsers]="(allUsers$ | async) ?? []"
        [allStrategies]="(allStrategies$ | async) ?? []"
        (close)="toggleGlobalChartDisplay(true)"
        (displayEventAnnotationChange)="toggleEventAnnotationDisplay($event)"
      >
        <canvas
          baseChart
          class="chart mb-3"
          [datasets]="globalDataset.chartDataSet"
          type="line"
          [labels]="globalDataset.labels"
          [options]="globalDataset.lineChartOptions"
        ></canvas>
      </chart-layout>
    } @else {
      <div class="flex justify-end">
        <IButton
          color="white"
          [label]="t('agency-board.show_global_chart')"
          tooltipValue="{{ t('agency-board.show_global_chart') }}"
          [icon]="ICON_CHART"
          (onClick)="toggleGlobalChartDisplay(false)"
        />
      </div>
    }

    <grid-layout>
      <div class="flex w-full flex-col gap-2">
        <div class="flex justify-between">
          <IButton
            color="white"
            [label]="
              isGroupByParent ? t('product-tracker.split_by_child_asin') : t('product-tracker.group_by_parent_asin')
            "
            (onClick)="toggleParentAsin()"
          />
          <div class="flex gap-2">
            <IButton
              color="white"
              [label]="t('common.restore_columns')"
              tooltipValue="{{ t('common.restore_columns') }}"
              (onClick)="restoreDefaultColumns()"
            />
            <app-export-button tooltipValue="{{ t('common.export_as_csv') }}" (export)="exportGridCsv()" />
          </div>
        </div>
        <ag-grid-angular
          class="ag-theme-quartz h-[45rem] w-full"
          #grid
          [columnDefs]="columnDefs"
          [rowData]="gridData"
          [gridOptions]="gridOptions"
          [animateRows]="true"
          (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
        />
      </div>
    </grid-layout>
  </div>
</ng-container>
